module.exports = __webpack_public_path__ + "static/media/health.04dad11f.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/industry/health.png
// module id = 789
// module chunks = 0